
import { computed, defineComponent } from 'vue';
import { RARITY_COLOR_MAP } from '@store/modules/char';
export default defineComponent({
  name: 'CharStartHead',
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    rarity: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
    isReal: {
      type: Boolean,
      required: true,
    },
    ring: {
      type: String,
      required: true,
    },
    ringDetail: {
      type: String,
      default: '',
    },
    start: {
      type: String,
      required: true,
    },
    charListImg: {
      type: String,
      required: true,
    },
  },
  setup(props: any) {
    const start = Number(props.start);
    const bgColor = computed(() => {
      return `${RARITY_COLOR_MAP[props.rarity]}`;
    });
    const startInfo = {
      color: start > 5 ? 'red' : 'yellow',
      num: start > 5 ? start - 5 : start,
    };

    return {
      bgColor,
      startInfo,
    };
  },
});
